export const calculateBeats = (beatsPerBar: number, rhytm: string) => {
  let beats = 0;
  if (/^[SQ()a&\s¤]+$/.test(rhytm)) {
    // calculate S and Q
    const rhytmArray = rhytm.split("");
    let i = 0;
    while (i < rhytmArray.length) {
      if (rhytmArray[i] === "S") {
        if (beatsPerBar === 2) {
          beats += 1;
        } else if (beatsPerBar === 4) {
          beats += 2;
        } else {
          throw new Error("Invalid beats per bar");
        }
      } else if (rhytmArray[i] === "Q") {
        if (beatsPerBar === 2) {
          beats += 0.5;
        } else if (beatsPerBar === 4) {
          beats++;
        } else {
          throw new Error("Invalid beats per bar");
        }
      }
      i++;
    }
  } else if (/^[1-8()a&\s¤]+$/.test(rhytm)) {
    // calculate W
    const rhytmArray = rhytm.split("");
    let i = 0;
    while (i < rhytmArray.length) {
      if (
        rhytmArray[i] === "1" ||
        rhytmArray[i] === "2" ||
        rhytmArray[i] === "3" ||
        rhytmArray[i] === "4" ||
        rhytmArray[i] === "5" ||
        rhytmArray[i] === "6" ||
        rhytmArray[i] === "7" ||
        rhytmArray[i] === "8"
      ) {
        beats++;
      }
      i++;
    }
  } else if (/^[0-9]+\sbar(s){0,1}$/.test(rhytm)) {
    const rhytmArray = rhytm.split(" ");
    beats = parseInt(rhytmArray[0]) * beatsPerBar;
  }
  return beats;
};
